import React, { Component } from 'react';
import { Link } from 'react-router-dom';


class SingleSaleryFull extends Component {

    render() {
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-12 text-center">
                                <h1 className="color-grey capitalize">Driver Salary</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    {/* START: Breadcrumb Component */}
                    <ul className="breadcrumb">
                        <li><Link to='/hr/saleries'>Salaries</Link></li>
                        <li>Driver Salary</li>
                    </ul>
                    {/* END: Breadcrumb Component */}
                </div>
                <div className="container box inner-padding mb-15">
                    <div className="box-body">
                        <div className="row justify-between">
                            <div className="col-xs-6 pr-70">
                                <ul className="w-700 row">
                                    <li className="py-15 col-xs-6">
                                        <p className="font-sm color-grey50">Driver ID</p>
                                        <p className="color-primary mt-5"> 001</p>
                                    </li>
                                    <li className="py-15 col-xs-6">
                                        <p className="font-sm color-grey50">Driver Name</p>
                                        <p className="color-primary mt-5">Lilit Safaryan</p>
                                    </li>
                                </ul>
                                <ul className="w-700">
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Employment Type</p>
                                        <p className="color-primary">Full Time</p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Period</p>
                                        <p className="color-primary mt-5">01.04.2018-01.05.2018</p>
                                    </li>
                                </ul>
                                <div className="table py-15">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Restaurant Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>01.04.2018</td>
                                                <td>Tashir Pizza</td>
                                            </tr>
                                            <tr>
                                                <td>05.04.2018</td>
                                                <td>Fish Club</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <ul className="w-700 row">
                                    <li className="py-15 col-xs-6">
                                        <p className="font-sm color-grey50">Target</p>
                                        <p className="color-primary mt-5">500</p>
                                    </li>
                                    <li className="py-15 col-xs-6">
                                        <p className="font-sm color-grey50">Salary</p>
                                        <p className="color-primary mt-5">2500 SAR</p>
                                    </li>
                                </ul>
                                <ul className="w-700">
                                    <li className="w-700 py-15">
                                        <p className="font-sm color-grey50">Total Deliveries</p>
                                        <p className="color-primary mt-5">2</p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Total Salary</p>
                                        <p className="color-primary mt-5">15 SAR</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default SingleSaleryFull;



// WEBPACK FOOTER //
// ./src/components/Hr/SingleSaleryFull.js